import React from 'react'
import styled from 'styled-components'
import posthog from 'posthog-js'
import ShareIcon from '../../../images/share.svg'

const Image = styled.img`
    width: 32px;
`

/**
 * Copies the given text to clipboard.
 * @param {String} text text to copy
 */
const copyText = (text) => {
    const textarea = document.createElement('textarea')
    textarea.setAttribute('type', 'hidden')
    textarea.textContent = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
}

const ShareButton = ({ ...props }) => {
    const onClickShare = () => {
        posthog.capture('share_clicked')
        if (navigator.share) {
            navigator.share({
                title: 'Join this Crossword with me!',
                text: 'Join this Crossword with me!',
                url: window.location.href,
            }).catch(console.error)
        } else {
            copyText(window.location.href)
            window.alert('The URL has been copied to your clipboard!')
        }
    }

    return (
        <Image src={ShareIcon} onClick={onClickShare} {...props} />
    )
}

export default ShareButton
